<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" :disabled="addBtnLoading" @click="addOrUpdateHandle()" v-if="isAuth('quotationV:save')">Add Quotation (V)</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-input
                v-model="dataForm.keyword"
                :placeholder="kwPlaceHolder"
                class="wd500 input-with-select-lg"
                :class="{ hideInputActive: dataForm.noClientCode || dataForm.noLinkedEngagement }"
              >
                <el-select v-model="dataForm.kwType" slot="prepend" placeholder="please select" @change="kwTypeChange">
                  <el-option v-for="item in kwTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
            <el-form-item>
              <business-info-select-remote-search v-model="dataForm.applymentNo" placeholder="Transaction No."></business-info-select-remote-search>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.status" multiple clearable placeholder="Status" class="wd160">
                <el-option v-for="item in adjustmentStatusList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <div>
      <el-table
        max-height="680"
        :data="dataList"
        v-loading="dataListLoading"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <!-- 展开 -->
        <el-table-column type="expand" width="30px" fixed="left">
          <template slot-scope="props">
            <Expand
              :itemList="props.row.itemList || []"
              :bankAccountIds="props.row.bankAccountIds || []"
              :supplierBankAccountList="supplierBankAccountList"
            />
          </template>
        </el-table-column>

        <el-table-column prop="adjustmentNo" align="center" label="Quotation (V)" sortable="custom" width="150" fixed="left" />
        <el-table-column prop="applymentNo" align="center" label="Trans No." width="100" fixed="left" />
        <el-table-column align="center" label="Supplier" width="150" fixed="left">
          <template slot-scope="scope">
            <p>{{ scope.row.supplier?.abbr || "" }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="clientCode" align="center" label="Client Code" width="110" />
        <el-table-column prop="billingParty" align="center" label="Billing Party" min-width="200" />
        <el-table-column prop="address" align="center" label="Address" min-width="250" />
        <el-table-column prop="country" align="center" label="Country" min-width="120" />
        <el-table-column prop="postalCode" align="center" label="Postal Code" min-width="110" />
        <el-table-column prop="applyReason" align="center" label="Description / Apply Reason" min-width="250" />
        <el-table-column prop="attachmentUrls" align="center" label="Attachments" min-width="130">
          <template slot-scope="scope">
            <p v-for="item in scope.row.attachmentUrls" :key="item.url">
              <a :href="item.url" target="_target">{{ item.name }}</a>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" sortable="custom" min-width="130" />
        <el-table-column prop="status" align="center" label="Status" min-width="144">
          <template slot-scope="scope">
            <div class="fxRow">
              <p class="mr4">{{ adjustmentStatusFormat(scope.row.status) }}</p>
              <el-link type="primary" :underline="false" @click="openStatusHistoryModal(scope.row)">(Track)</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Linked Engagement ID" width="184">
          <template slot-scope="scope">
            <span v-if="scope.row.engagementList?.length > 0">{{ engagementIdDeduplicateFormat(scope.row.engagementList) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transactionType" align="center" label="Transaction Type" width="150">
          <template slot-scope="scope">
            <p>{{ transactionTypeFormat(scope.row.transactionType) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="120" label="Order Status">
          <template slot-scope="scope">
            <p>{{ orderStatusFormat(scope.row?.customerOrder?.status) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="Action" fixed="right">
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-button
              v-if="isAuth('quotationV:update') && (scope.row.status == 'PENDING' || scope.row.status == 'REJECTED')"
              type="text"
              class="fwb"
              @click="addOrUpdateHandle(scope.row)"
            >
              Edit
            </el-button>
            <!-- 审批 -->
            <el-button v-if="isAuth('quotationV:audit') && scope.row.status == 'PENDING'" type="text" class="fwb" @click="reviewHandle(scope.row)">
              Review
            </el-button>
            <!-- 删除 -->
            <el-button
              v-if="isAuth('quotationV:delete') && (scope.row.status == 'PENDING' || scope.row.status == 'REJECTED')"
              type="text"
              class="fwb"
              @click="deleteHandle(scope.row)"
            >
              Delete
            </el-button>
            <!-- 禁用 -->
            <el-button
              v-if="
                isAuth('quotationV:forfeit') &&
                scope.row.status == 'PASSED' &&
                scope.row.customerOrder &&
                (scope.row.customerOrder.status == 'UNPAID' || scope.row.customerOrder.status == 'PARTLY_PAID')
              "
              type="text"
              class="fwb"
              @click="statusUpdateHandle(scope.row, 'Forfeit')"
            >
              Forfeit
            </el-button>
            <!-- 启用 -->
            <el-button
              v-if="
                isAuth('quotationV:reActive') &&
                scope.row.status == 'FORFEITED' &&
                scope.row.customerOrder &&
                (scope.row.customerOrder.status == 'UNPAID' ||
                  scope.row.customerOrder.status == 'PARTLY_PAID' ||
                  scope.row.customerOrder.status == 'FORFEITED')
              "
              type="text"
              class="fwb"
              @click="statusUpdateHandle(scope.row, 'Re-active')"
            >
              Re-active
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      ref="addOrUpdate"
      :supplierList="supplierList"
      :invoiceTemplateList="invoiceTemplateList"
      @refreshDataList="getDataList"
    ></add-or-update>
    <!-- 状态操作日志弹框 -->
    <status-history ref="statusHistoryModal"></status-history>
    <!-- client code 复核弹框 -->
    <supplement-review ref="supplementReviewModal" @refreshStatus="getDataList"></supplement-review>
  </div>
</template>

<script>
import Expand from "./components/Expand";
import AddOrUpdate from "./modal/AddOrUpdate";
import StatusHistory from "./modal/StatusHistory";
import SupplementReview from "./modal/SupplementReview";
import BusinessInfoSelectRemoteSearch from "@/components/SelectRemoteSearch/businessInfo";
import Pagination from "@/components/Pagination";
import searchMixin from "@/mixins/searchMixin";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
import formatterMixin from "@/mixins/formatterMixin";
import { mapState } from "vuex";
export default {
  mixins: [searchMixin, paginationMixin, tableMixin, formatterMixin],
  components: {
    Expand,
    AddOrUpdate,
    StatusHistory,
    SupplementReview,
    BusinessInfoSelectRemoteSearch,
    Pagination,
  },
  data() {
    return {
      kwTypes: [
        {
          title: "Quotation (V) No.",
          value: "adjustmentNo",
          placeholder: "Quotation (V) No.",
        },
        {
          title: "Billing Party",
          value: "billingParty",
          placeholder: "Billing Party",
        },
        {
          title: "Description",
          value: "applyReason",
          placeholder: "Description",
        },
        {
          title: "Client Code Blank",
          value: "clientCodeBlank",
          placeholder: "",
        },
        {
          title: "Linked Engagement ID Blank",
          value: "linkedEngagementIdBlank",
          placeholder: "",
        },
      ],
      dataForm: {
        kwType: "adjustmentNo",
        keyword: "",
        adjustmentNo: "",
        billingParty: "",
        applyReason: "",
        applymentNo: "",
        status: "",
        supplierId: "",
        noClientCode: null,
        noLinkedEngagement: null,
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      supplierList: [],
      invoiceTemplateList: [],
      supplierBankAccountList: [],
      dataListLoading: false,
      addBtnLoading: false,
    };
  },
  computed: {
    ...mapState("constant", ["adjustmentStatusList"]),
  },
  methods: {
    // kwType下拉框 - change
    kwTypeChange() {
      if (this.dataForm.kwType == "clientCodeBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noClientCode = true;
      } else {
        this.dataForm.noClientCode = null;
      }
      if (this.dataForm.kwType == "linkedEngagementIdBlank") {
        this.dataForm.keyword = "";
        this.dataForm.noLinkedEngagement = true;
      } else {
        this.dataForm.noLinkedEngagement = null;
      }
    },
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取发票模板列表
    getInvoiceTemplateList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/invoiceTemplate")
          .then(res => {
            const resData = res.data || [];
            this.invoiceTemplateList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取供应商银行账号列表
    getSupplierBankAccountList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplierBankAccount")
          .then(res => {
            const resData = res.data || [];
            this.supplierBankAccountList = resData;
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
        [this.dataForm.kwType]: this.dataForm.keyword,
      };
      params.amount = params.amount ? Number(params.amount) : params.amount;
      const { code, data } = await this.$http.get("/admin/adjustment/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 状态操作日志
    openStatusHistoryModal(row) {
      this.$refs.statusHistoryModal.init(row);
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdate.init(row);
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this quotation (v). Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/adjustment/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 审批
    reviewHandle(row) {
      this.$refs.supplementReviewModal.init(row);
    },
    // 禁用、启用
    async statusUpdateHandle(row, tipe) {
      await this.$confirm(`${tipe} This Quotation (V). Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      this.$http.post(`/admin/adjustment/${row.id}/${tipe == "Forfeit" ? "forfeit" : "reActive"}`, {}).then(({ code, msg }) => {
        if (code === 200) {
          this.$message.success("success");
          this.getDataList();
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 自动新增
    autoAddHandle() {
      const query = this.$route.query;
      if (query.applymentNo) {
        this.$refs.addOrUpdate.init(null, query.applymentNo);
      }
    },
  },
  async activated() {
    try {
      this.addBtnLoading = true;
      this.dataListLoading = true;
      await this.getSupplierList();
      await this.getInvoiceTemplateList();
      await this.getSupplierBankAccountList();
    } finally {
      this.addBtnLoading = false;
      this.getDataList();
      this.autoAddHandle();
    }
  },
};
</script>

<style lang="scss" scoped>
.hideInputActive {
  width: 200px !important;
  border-right: 1px solid #dcdfe6;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;

  ::v-deep .el-input-group__prepend + .el-input__inner {
    display: none;
  }
}
</style>
